import GridColumn from "../GridColumns/GridColumn";
import { DefaultHtmlAttributes } from "@syncfusion/ej2-react-base";
import {
  PredicateModel,
  SortDescriptorModel,
  GridModel,
} from "@syncfusion/ej2-react-grids";
import { BaseGridModel } from "../GridTypes/BaseGridModel";
import GridHeightSettings from "../GridSettings/GridHeightSettings";
import { Predicate } from "@syncfusion/ej2-data";

export interface GridSetup<T extends object> {
  gridKey: string;
  gridViewTitle?: string;
  dataSource: string;
  dataParams?: Record<string, string>;
  predicate?: Predicate;
  getAuthRequestHeader: () => Promise<Record<string, string> | undefined>;
  columnsConfiguration: Readonly<GridColumn[]>;
  filterConfiguration?: PredicateModel[];
  sortConfiguration?: SortDescriptorModel[];
  gridConfiguration?: Readonly<BaseGridModel<T>>;
  gridHeightSettings?: GridHeightSettings;
  setupActions?: (columnsConfiguration: GridColumn[]) => GridColumn[];
  allowSearch?: boolean;
}

export const defaultGridSettings: GridModel & DefaultHtmlAttributes = {
  enableColumnVirtualization: true,
  enableInfiniteScrolling: true,
  allowReordering: true,
  allowResizing: true,
  resizeSettings: { mode: "Normal" },
  pageSettings: { pageSize: 20 },
  allowExcelExport: true,
  allowSorting: true,
  allowFiltering: true,
  loadingIndicator: { indicatorType: "Shimmer" },
  enableVirtualMaskRow: true,
  filterSettings: {
    type: "Excel",
    ignoreAccent: true,
    operators: {
      stringOperator: [{ value: "contains", text: "Contains " }],
    },
  },
  toolbar: [],
  searchSettings: {
    operator: "contains",
    ignoreCase: true,
  },
};
